import { useContext } from '@wordpress/element';
import Context from '../context/context';

const Notes = () => {
    const context = useContext(Context);
    const { groupData } = context;

    return (
        <>
            <div className="mini-table-source" id="notes">
                † Among foreign born. <br /> Note:{' '}
                <span id="country-specific-note" />{' '}
                <span id="general-note">
                    {'' === groupData.note
                        ? 'Chinese includes those identifying as Taiwanese. Based on mixed-race and mixed-group populations, regardless of Hispanic origin. There is some overlap between groups due to individuals identifying with multiple Asian groups.'
                        : groupData.note}{' '}
                    <a href="https://www.pewsocialtrends.org/2017/09/08/methodology-asian-american-fact-sheets">
                        See methodology
                    </a>{' '}
                    for more detail.{' '}
                    {'' === groupData.note
                        ? ''
                        : 'See the accompanying fact sheets for detailed notes on each of the measures in this table.'}
                </span>
            </div>
        </>
    );
};

export default Notes;
